import { Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, PageSection, SectionGroup } from 'Components/Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { SieveSizeId, createSieveSizeCaptionGetter, createSieveSizeGetter } from 'Data/ViewModels/Equipment/ISieveSize';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';
import ConstantDryMassDeterminationSection from './ConstantDryMassDeterminationSection';

let InitialSeparationPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const separatingSieveSizeId: SieveSizeId = useSelector(createWorksheetSelector!('Separation.SeparatingSieveSizeId'));
  const separatingSieveSize = useSelector(
    pipe(
      createWorksheetSelector!('data.Equipment.AllSieveSizes', false),
      createSieveSizeGetter(separatingSieveSizeId),
      (s) => s?.Size
    ),
    deepEquals
  );
  const separatingSieveSizeCaption = useSelector(
    pipe(
      createWorksheetSelector!('data.Equipment.AllSieveSizes', false),
      createSieveSizeCaptionGetter(separatingSieveSizeId),
      valueOrDefault('N/A')
    )
  );

  return (
    <PageSection heading="Initial Separation">
      <NamePrefixModifier appendNamePrefix="Separation">
        <ListFieldSection>
          <Field input={<TextOutput />} name="SeparatingSieveSizeId" value={separatingSieveSizeCaption} />
          <Field
            input={<WorksheetEquipmentDropdown />}
            name="SeparatingSieve"
            label="Separating Sieve"
            equipmentType="sieve"
            queryParams={{ SieveSize: `${separatingSieveSize?.value} ${separatingSieveSize?.uom}` }}
          />
          <Field
            input={<WorksheetEquipmentDropdown />}
            name="CoarsePortion.Masses.MassMeasurement.Equipment.Oven"
            label="Oven"
            equipmentType="oven"
            copyTo={['FinePortion.Masses.MassMeasurement.Equipment.Oven']}
          />
        </ListFieldSection>

        <NamePrefixModifier appendNamePrefix="CoarsePortion.Masses.MassMeasurement.MeasuredConstantDryMass">
          <SectionGroup heading="Coarse Portion Constant Dry Mass">
            <ConstantDryMassDeterminationSection />
          </SectionGroup>
        </NamePrefixModifier>

        <NamePrefixModifier appendNamePrefix="FinePortion.Masses.MassMeasurement.MeasuredConstantDryMass">
          <SectionGroup heading="Fine Portion Constant Dry Mass">
            <ConstantDryMassDeterminationSection />
          </SectionGroup>
        </NamePrefixModifier>
      </NamePrefixModifier>

      <ListFieldSection>
        <Field input={<TextOutput />} name="Masses.DryMass" label="Specimen Total Dry Mass" />
      </ListFieldSection>
    </PageSection>
  );
};
InitialSeparationPageSection = withInjectedProps(InitialSeparationPageSection);

export { InitialSeparationPageSection };
export default InitialSeparationPageSection;
